import { useCallback, useMemo, useState } from "react";

import type { DateRange } from "@/components/ui/calendar/types/calendar-range";

import type { SearchTypeForSearchSalesMastList } from "../../../../../model/constants";
import type { OnSearchSalesMastListProps } from "../../../../../model/use-case/use-search-reservation-list";

/**
 * 日付での検索
 */
type DateRangeCase = {
	from?: string;
	to?: string;
};

type SearchState = DateRangeCase;

type Props = {
	onSearchSalesMastList: (props: OnSearchSalesMastListProps) => void;

	searchType: SearchTypeForSearchSalesMastList;
	onSetSearchType: (type: SearchTypeForSearchSalesMastList) => void;
};

export const useHandleSearchActions = ({
	onSearchSalesMastList,
	searchType,
	onSetSearchType, //
}: Props) => {
	const [searchState, setSearchState] = useState<SearchState>({ from: "" });

	/**
	 * 収支検索タイプの変更
	 */
	const handleChangeSearchType = useCallback(
		(searchType: string) => {
			onSetSearchType(searchType as SearchTypeForSearchSalesMastList);
		},
		[onSetSearchType],
	);

	/**
	 * 日付の変更
	 */
	const handleChangeFromAndTo = useCallback(({ from, to }: DateRange) => {
		setSearchState((prev) => ({ ...prev, from: from, to: to }));
	}, []);

	/**
	 * 日付での検索
	 */
	const onSearchSalesMastListByRangeDate = useCallback(
		({ from, to }: { from: string; to: string }) => {
			onSearchSalesMastList({ from, to });
		},
		[onSearchSalesMastList],
	);

	/**
	 * 収支の検索
	 */
	const handleClickSearchSalesMastList = useCallback(() => {
		if (!searchState.from) return;

		const from = searchState.from;
		/**
		 * 日付の範囲が指定されていない場合は、開始日と終了日を同じにする
		 */
		const to = searchState.to ?? from;
		onSearchSalesMastListByRangeDate({ from, to });
	}, [onSearchSalesMastListByRangeDate, searchState.from, searchState.to]);

	const disabled = useMemo(() => {
		return !(searchState.from && searchState.to);
	}, [searchState]);

	return {
		searchState,

		searchType,
		onSetSearchType,

		//
		disabled,
		//
		// 収支タイプの変更
		handleChangeSearchType,
		// 日付の変更
		handleChangeFromAndTo,
		// 収支の検索
		handleClickSearchSalesMastList,
	};
};
